export default "__VITE_ASSET__CadTCDEm__"